var map = {
	"./arrow_icon.png": 1462,
	"./float_bc.png": 5615,
	"./float_bc_active.png": 6266,
	"./junpintan.png": 8606,
	"./light.png": 1887,
	"./logo.png": 6870,
	"./next.png": 960,
	"./next2.png": 1792,
	"./page_2_bc.png": 5679,
	"./page_3_bc.png": 8268,
	"./page_3_swiper_bc.png": 135,
	"./page_4_bc.png": 9285,
	"./people_after.png": 97,
	"./people_before.png": 5294,
	"./play.png": 7629,
	"./play_main.png": 209,
	"./play_white.png": 2627,
	"./prev.png": 8084,
	"./prev2.png": 9564,
	"./xi_image.png": 6488,
	"./xi_text.png": 1274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9415;